import { useUserStore } from '@/stores/user'
import { useMiscStore } from '@/stores/misc'
import { designTeam } from '@/api/affairs'
// const userStore = useUserStore()
// const islogin = userStore.isLoggedIn

export const initClient = () => {
    const userStore = useUserStore()
    const miscStore = useMiscStore()
    const islogin = userStore.isLoggedIn
    if (!islogin) {
        return
    }
    return new Promise((resolve, reject) => {
        //@ts-ignore
        Auth.ins.getClientJssdkInitData({
            clientId: miscStore.getClientID(),
            jsApiList: [],
            onSuccess: async (res) => {
                //@ts-ignore
                await Auth.ins.config({
                    ...res,
                    notListenGroupChange: true,
                })
                //@ts-ignore
                Auth.request.requestor({
                    url: "/open/jssdk/verify",
                    method: "POST",
                    data: res,
                }).then(async (result) => {
                    await getTeamList(result)
                    resolve(result)
                })
            },
        });
    })
}

const getTeamList = (result: any) => {
    return new Promise((resolve, reject) => {
        const userStore = useUserStore()
        //@ts-ignore
        const initial = result.current_team
        designTeam({ corpInfo: initial })
        userStore.setCurrentTeamInfo(initial)
        //@ts-ignore
        Auth.request.requestor({
            url: "/open/jssdk/user/teams",
            method: "get",
        }).then((result) => {
            let personl = [{
                corp_code: '',
                name: result.users.name,
                icon_url: result.users.avatar,
                employee_count: 0,
            }]

            //@ts-ignore
            let teamList = [...personl, ...result.teams] as any[]
            userStore.setTeamList(teamList)
            const enriched = (teamList || []).find((item: any) => item.corp_code == initial.corp_code) || initial
            userStore.setCurrentTeamInfo(enriched)
            resolve(enriched)
        })
    })
}
